import { useCallback, useState } from "react";
import { GridRowSelectionModel } from "@mui/x-data-grid-pro";
import { FixedRule } from "repository/timekeeper/@types/FixedRuleModel";

export const useFixRuleTableState = () => {
    const [contextMenu, setContextMenu] = useState<{ mouseX: number; mouseY: number } | null>(null);
    const [selectedRow, setSelectedRow] = useState<FixedRule[]>([]);
    const [selected, setSelected] = useState<GridRowSelectionModel>([]);

    const cleanSelected = useCallback(() => {
        setSelectedRow([]);
        setSelected([]);
    }, []);

    return {
        contextMenu,
        setContextMenu,
        selectedRow,
        setSelectedRow,
        selected,
        setSelected,
        cleanSelected,
    };
};
